import ecoSystem from 'constants/ecoSystem'
import formatNum2Dp from 'utils/formatNum2DP'
import formatNum4Dp from 'utils/formatNum4DP'

const SYSTEM_VALUE_BY_FLAG = {
  terrestrial_system: 1,
  marine_system: 2,
  freshwater_system: 3,
  subterranean_system: 4
}

const isKnownSystemId = (id) => ecoSystem.some((option) => option.value === id)

export const buildSelectedSystems = (siteData = {}) => {
  const fromBooleans = Object.entries(SYSTEM_VALUE_BY_FLAG)
    .filter(([flag]) => siteData[flag])
    .map(([, value]) => value)

  if (fromBooleans.length > 0) {
    return fromBooleans
  }

  const legacyIds = [
    siteData.EcoSystemsId,
    siteData.EcoSystems2LargestId,
    siteData.EcoSystems3LargestId,
    siteData.EcoSystemsSmallestId
  ].filter((id) => id != null && isKnownSystemId(id))

  return [...new Set(legacyIds)]
}

const getFormattedNumericValue = (value, formatter) => {
  if (value === null || value === undefined || value === '') {
    return ''
  }

  return formatter(value)
}

export const buildDetailsInitialState = (siteData = {}) => {
  const sensitiveSite = Object.prototype.hasOwnProperty.call(siteData, 'sensitive_site')
    ? Boolean(siteData.sensitive_site)
    : Boolean(siteData.sensitiveSite)
  const sensitiveSiteDetails = Object.prototype.hasOwnProperty.call(siteData, 'sensitive_site_details')
    ? (siteData.sensitive_site_details || '')
    : (siteData.sensitiveSiteDetails || '')

  return {
    selectedSystems: buildSelectedSystems(siteData),
    name: siteData.name || '',
    siteNameNational: siteData.siteNameNational || '',
    countryCode: siteData.SiteDetailsCountryId,
    state: siteData.state || '',
    siteArea: getFormattedNumericValue(siteData.siteArea, formatNum2Dp),
    latitudeOfMidPoint: getFormattedNumericValue(siteData.latitudeOfMidPoint, formatNum4Dp),
    longitudeOfMidPoint: getFormattedNumericValue(siteData.longitudeOfMidPoint, formatNum4Dp),
    highestAltitude: getFormattedNumericValue(siteData.highestAltitude, formatNum2Dp),
    lowestAltitude: getFormattedNumericValue(siteData.lowestAltitude, formatNum2Dp),
    minimumDepth: getFormattedNumericValue(siteData.minDepth, formatNum2Dp),
    maximumDepth: getFormattedNumericValue(siteData.maxDepth, formatNum2Dp),
    rationaleForSiteInformation: siteData.rationaleForSiteInformation || '',
    siteDescription: siteData.siteDescription || '',
    sensitiveSite,
    sensitiveSiteDetails,
    howIsTheSiteManaged: siteData.howIsTheSiteManaged || '',
    deliniationRationale: siteData.deliniationRationale || '',
    boundarySource: siteData.boundary_source || '',
    coveredByWhatProtectedAreas: siteData.coveredByWhatProtectedAreas || '',
    additionalBiodiversityValues: siteData.additionalBiodiversityValues || '',
    landUseRegimesAtSite: siteData.landUseRegimesAtSite || '',
    coveredByPa: getFormattedNumericValue(siteData.calculatedProtectedArea, formatNum2Dp),
    coveredByOECM: getFormattedNumericValue(siteData.calculatedOECMArea, formatNum2Dp),
    paUserUpdated: getFormattedNumericValue(siteData.pa_user_updated, formatNum2Dp),
    paUserUpdatedJustification: siteData.pa_user_updated_justification || '',
    oecmUserUpdated: getFormattedNumericValue(siteData.oecm_user_updated, formatNum2Dp),
    oecmUserUpdatedJustification: siteData.oecm_user_updated_justification || '',
    threatsDescription: siteData.threatsDescription || '',
    supersidedSites: siteData.supersededSitesDesription || '',
    notes: siteData.notes || '',
    habitat: siteData.habitatDescription || '',
    indigenousGroups: siteData.indigenousGroups || '',
    references: siteData.references || '',
    contributors: siteData.consultationWithContributors || ''
  }
}
